<template>
  <div class="home">
    <MenuNavegacion />
    <MenuNavegacionMovil />
    <ModalTerminosAvisos />
    <transition appear name="slide-fade">
      <router-view></router-view>
    </transition>
    <aviso-cookies
      :idioma="
        tipoPersona != 2 && tipoPersona != 5 && tipoPersona != 7 ? 'ES' : 'EN'
      "
    ></aviso-cookies>
    <Footer></Footer>
  </div>
</template>

<script lang="js">
import axios from "axios";
import MenuNavegacion from "../Componentes/MenuNavegacion.vue";
import MenuNavegacionMovil from "../Componentes/MenuNavegacionMovil.vue";
import ModalTerminosAvisos from "../Componentes/ModalTerminosAvisos.vue";
import Footer from "../Componentes/Footer.vue";
import AvisoCookies from "../Componentes/AvisoCookies.vue";
import servicios from '../servicios/service.js';

var rutaObtenerPantalla = "/api/Master/Etapa/ConsultarVistaFlujoProspecto";

export default {
  name: "Home",
  data() {
    return {
      embajadoresInactivo: 0,
      embajadores: 1,
      prospectoInactivo: 2,
      prospecto: 3,
      preautorizador: 4,
      administrador: 5,
      gerente: 6,
      masterComercial: 7,
      masterOperativo: 8,
      gerenteRegional: 9,
      administradorComercial: 10,
      TipoUsuario: null,
      primerAcceso: false,
      sesionActiva: true,
      ProspectoId: null,
      tipoPersona: null,
      zona: 0
    }
  },
  components: {
    MenuNavegacion,
    MenuNavegacionMovil,
    ModalTerminosAvisos,
    Footer,
    AvisoCookies
  },
  mounted(){
    setTimeout(() => {this.ValidarTiempoInactividad();}, 60000 * 60 * 24);

    var rutaActual = this.$route.name;
    this.ProspectoId = this.$store.getters.prospectoId;
    this.primerAcceso = sessionStorage.getItem("primerAcceso") == "true" ? true : false;
    if(this.primerAcceso)
    {
      this.$store.commit("setAvisoPrivacidadAceptado", false);
    }
    else
    {
      this.$store.commit("setAvisoPrivacidadAceptado", true);
    }
    this.TipoUsuario = this.$store.getters.tipoUsuario;
    this.tipoPersona = this.$store.getters.tipoPersona;
    this.zona = this.$store.getters.zona;
    switch (this.TipoUsuario) {
      case this.embajadores:
      case this.preautorizador:
      case this.administrador:
      case this.gerente:
      case this.masterOperativo:
      case this.gerenteRegional:
      case this.administradorComercial:
        if(rutaActual != "AdministracionDeProspectos") {
          this.$router.push({
            name: "AdministracionDeProspectos"
          });
        }
        break;
      case this.prospecto:
        if(sessionStorage.getItem("primerAcceso") == "true" && this.TipoUsuario == 3){
          if(rutaActual != "Bienvenida") {
            this.$router.push({
              name: "Bienvenida"
            });
          }
        } else {
          this.RedirigirPantalla();
          if(rutaActual != "SeguimientoProspecto") {
            this.$router.push({
              name: "SeguimientoProspecto"
            });
          }
        }
        break;
      case this.masterComercial:
        if(rutaActual != "Dashboard2") {
          this.$router.push({
            name: "Dashboard2"
          });
        }
        break;
      case 11: //SuperAdmin
          if(rutaActual != "BibliotecaDigital") {
          this.$router.push({
            name: "BibliotecaDigital"
          });
        }
        break;
    default:
      break;
    }
  },
  methods:{
    ValidarTiempoInactividad(){
      if(window.sessionStorage.getItem("Token") != null){
        this.$store.commit('setSesionActiva', false);
        this.$fire({
          title: (this.tipoPersona == 2 || this.tipoPersona == 5 || this.tipoPersona == 7) ? "Hello, we have noticed that you are inactive." : "¡Hola!, hemos notado que estás inactivo.",
          html: (this.tipoPersona == 2 || this.tipoPersona == 5 || this.tipoPersona == 7) ? "<br>For security reasons, we will automatically log you out.<br> Select the <b>stay</b> button, to stay on the platform." : "<br>Por seguridad, se cerrará automáticamente tu sesión.<br> Selecciona el botón <b>continuar</b>, para mantenerte en la plataforma.<br><br>",
          showConfirmButton: true,
          showCancelButton: false,
          confirmButtonText: (this.tipoPersona == 2 || this.tipoPersona == 5 || this.tipoPersona == 7) ? "Stay" : "Continuar",
          allowOutsideClick: false,
          timer:30000
        }).then(result => {
          if (result.value) {
            this.$store.commit('setSesionActiva', true);
          }
        });
        setTimeout(() => {
          if(this.$store.getters.sesionActiva == false){
            servicios.CerrarSesion();
          }
        }, 30000);
      }
    },
     RedirigirPantalla(){
      let tipoPersona = this.$store.getters.tipoPersona;
      let prospectoId = this.ProspectoId;
      const parametroProspecto = {
        params:{
          prospectoId: prospectoId
        }
      }
    axios
      .get(rutaObtenerPantalla,parametroProspecto)
      .then((resp) => {
        if (resp.data.estado === 0) {
          if(resp.data.data != "") {
            let pantalla = resp.data.data;
            if(pantalla == "PreAutorizacion" && (this.TipoUsuario == 4)) {
              this.$router.push({
                name: pantalla
              });
            } else if ((this.TipoUsuario == 3 && pantalla == "PreAutorizacion") || ((this.TipoUsuario == 1) && pantalla == "PreAutorizacion")) {
              this.AlertaEmbajadores(servicios.CrearMensaje(this.TipoUsuario, tipoPersona, pantalla), true, (tipoPersona == 2 || tipoPersona == 5 || tipoPersona == 7) ? true : false);
            } else if ((this.TipoUsuario == 3 && pantalla == "GenerarInformacionDePago") || ((this.TipoUsuario == 1 || this.TipoUsuario == 6 || this.TipoUsuario == 9) && pantalla == "GenerarInformacionDePago")) {
              this.AlertaEmbajadores(servicios.CrearMensaje(this.TipoUsuario, tipoPersona, pantalla), true, (tipoPersona == 2 || tipoPersona == 5 || tipoPersona == 7) ? true : false);
            }else if((this.TipoUsuario == 3 && pantalla == "ValidarPago") || ((this.TipoUsuario == 1 || this.TipoUsuario == 6 || this.TipoUsuario == 9) && pantalla == "ValidarPago")) {
              this.AlertaEmbajadores(servicios.CrearMensaje(this.TipoUsuario, tipoPersona, pantalla), true, (tipoPersona == 2 || tipoPersona == 5 || tipoPersona == 7) ? true : false);
            } else if((this.TipoUsuario == 1 && pantalla == "CargarInformacionDePago") || (this.TipoUsuario == 4 && pantalla == "CargarInformacionDePago")|| (this.TipoUsuario == 5 && pantalla == "CargarInformacionDePago") || (this.TipoUsuario == 6 && pantalla == "CargarInformacionDePago") || (this.TipoUsuario == 9 && pantalla == "CargarInformacionDePago")) {
              this.AlertaEmbajadores(servicios.CrearMensaje(this.TipoUsuario, tipoPersona,pantalla), true, (tipoPersona == 2 || tipoPersona == 5 || tipoPersona == 7) ? true : false);
            } else if((this.TipoUsuario == 1 || this.TipoUsuario == 6 || this.TipoUsuario == 9) && pantalla == "CajaDorada"){
              this.AlertaEmbajadores("El prospecto ya se encuentra contratado y tiene acceso a su Kit de Bienvenida.", true, false);
            }
             else if((this.TipoUsuario == 1 || this.TipoUsuario == 5 || this.TipoUsuario == 6 || this.TipoUsuario == 9 || this.TipoUsuario == 4 ) && pantalla == "SeguimientoProspecto"){
              this.AlertaEmbajadores("El prospecto ya completado su proceso.", true, false);
            }
            else if((this.TipoUsuario == 1 || this.TipoUsuario == 5 || this.TipoUsuario == 6 || this.TipoUsuario == 9 || this.TipoUsuario == 4 ) && pantalla == "HojaPrueba"){
              this.AlertaEmbajadores("El prospecto se encuentra en validación de Hoja de Prueba.", true, false);
            }
            else {
              this.$router.push({name: pantalla});
            }
          } else {
            this.AlertaEmbajadores(resp.data.mensaje, true, false);
          }
        } else if (resp.data.estado === 1) {
          this.AlertaEmbajadores(resp.data.mensaje, true, false);
        }
      })
      .catch((e) => {
        this.ManejarExcepcion(e);
      });
    }
  }
};
</script>

<style scoped lang="scss">
//Se importa el archivo para los estilos generales.
@import "../../../assets/estilos/estilosgenerales.scss";

.home {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
</style>
